(function () {
  'use strict';
  if (window.__inesNewsletterPopupLoaded) return;
  window.__inesNewsletterPopupLoaded = true;

  var activePopup = null;
  var initialized = new WeakSet();
  var dismissedKey = 'ines_newsletter_popup_dismissed_until';
  var subscribedKey = 'ines_newsletter_subscribed';
  var seenKey = 'ines_newsletter_popup_seen';
  var triggerSelector = '#newsletter-popup-trigger, .ines-cta-newsletter button, .ines-cta-newsletter a, [data-newsletter-popup-open]';
  var params = new URL(window.location.href).searchParams;
  var forced = params.get('newsletter_popup') === '1';

  function read(storage, key) {
    try { return window[storage].getItem(key); } catch (error) { return null; }
  }
  function write(storage, key, value) {
    try { window[storage].setItem(key, value); } catch (error) { /* Storage is optional. */ }
  }
  function excludedRoute() {
    return /^\/(?:cart|checkout|checkouts|account)(?:\/|$)/.test(window.location.pathname)
      || /^\/pages\/(?:merci-[^/]*|bac|brevet)\/?$/.test(window.location.pathname);
  }
  function subscribed() { return read('localStorage', subscribedKey) === '1'; }
  function suppressed(once) {
    return subscribed() || Number(read('localStorage', dismissedKey)) > Date.now()
      || read('sessionStorage', seenKey) === '1'
      || (once && read('localStorage', seenKey) === '1');
  }
  function anotherOverlay(dialog) {
    return Array.from(document.querySelectorAll('dialog[open]')).some(function (other) { return other !== dialog; })
      || !!document.querySelector('cart-drawer.active, cart-notification.active, .cart-notification.active, details[open] cart-drawer, details[open] > .menu-drawer, details[open] > .cart-drawer');
  }
  function footerVisible() {
    var footer = document.getElementById('footer-newsletter');
    if (!footer || !footer.getClientRects().length) return false;
    var box = footer.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom > 0;
  }

  function initializeSteps(dialog) {
    var form = dialog.querySelector('form[data-newsletter-steps]');
    if (!form || !form.dataset.newsletterSteps) return null;
    var profile = form.querySelector('[data-newsletter-step="profile"]');
    var emailPanel = form.querySelector('[data-newsletter-step="email"]');
    var back = form.querySelector('[data-newsletter-step-back]');
    var persona = form.elements.namedItem('persona');
    var level = form.elements.namedItem('level');
    var email = form.elements.namedItem('contact[email]');
    if (!profile || !emailPanel || !back || !persona || !level || !email) return null;
    var levelField = form.querySelector('[data-newsletter-level-field]');
    var summary = form.querySelector('[data-newsletter-profile-summary]');
    var progress = dialog.querySelector('[data-newsletter-step-count]');
    var status = form.querySelector('[data-newsletter-status]');
    var profileStepLabel = dialog.dataset.popupStepProfileLabel || 'Étape 1 sur 2';
    var emailStepLabel = dialog.dataset.popupStepEmailLabel || 'Étape 2 sur 2';
    var step = 'profile';
    var complete = false;
    var advanceTimer;
    var browsingLevel = false;
    var personas = ['parent', 'eleve'];
    var levels = ['6eme', '5eme', '4eme', '3eme', 'seconde', 'premiere', 'terminale'];

    function personaLabel(value) {
      return value === 'eleve'
        ? (dialog.dataset.popupStudentLabel || 'Élève')
        : (dialog.dataset.popupParentLabel || 'Parent');
    }
    function clearStatus() {
      if (status) { status.hidden = true; status.textContent = ''; }
    }
    function focusField(field) {
      var segments = profile.querySelector('[data-newsletter-segments][data-name="' + field.name + '"]');
      var dropdown = field.closest('[data-newsletter-dropdown]');
      var control = segments && segments.querySelector('[role="radio"][tabindex="0"]:not(:disabled)');
      if (!control && dropdown) control = dropdown.querySelector('[data-newsletter-select-trigger]');
      (control || field).focus({ preventScroll: true });
    }
    function focusProfile() {
      focusField(persona.type !== 'hidden' && !persona.value ? persona : level);
    }
    function focusCurrent() {
      if (complete) {
        if (status) { status.tabIndex = -1; status.focus({ preventScroll: true }); }
      } else if (step === 'email') email.focus({ preventScroll: true });
      else focusProfile();
    }
    function resize() {
      if (!dialog.open || !dialog.isConnected) return;
      var width = dialog.getBoundingClientRect().width;
      if (!width) return;
      var clone = dialog.cloneNode(true);
      clone.dataset.profilePending = 'false';
      clone.dataset.popupStep = 'email';
      clone.querySelector('form[data-newsletter-steps]').dataset.newsletterSteps = 'email';
      clone.inert = true;
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
      clone.querySelectorAll('[autofocus]').forEach(function (element) { element.removeAttribute('autofocus'); });
      function style(element, rules) {
        if (!element) return;
        Object.keys(rules).forEach(function (property) { element.style.setProperty(property, rules[property], 'important'); });
      }
      style(clone, { display: 'block', position: 'fixed', inset: 'auto', top: '0', left: '-100000px', margin: '0',
        width: width + 'px', height: 'auto', 'max-height': 'none', 'min-height': '0', visibility: 'hidden',
        'pointer-events': 'none', 'box-sizing': 'border-box', '--ines-popup-height': 'auto' });
      style(clone.querySelector('.ines-newsletter-popup__content'), { height: 'auto', 'max-height': 'none', 'grid-template-rows': 'auto' });
      style(clone.querySelector('.ines-newsletter-popup__form-panel'), { height: 'auto', 'max-height': 'none', overflow: 'visible', 'justify-content': 'flex-start' });
      var clonedProfile = clone.querySelector('[data-newsletter-step="profile"]');
      clonedProfile.hidden = true;
      style(clonedProfile, { display: 'none' });
      var clonedEmail = clone.querySelector('[data-newsletter-step="email"]');
      clonedEmail.hidden = false;
      clonedEmail.inert = false;
      clone.querySelector('[data-newsletter-step-back]').hidden = false;
      var clonedStatus = clone.querySelector('[data-newsletter-status]');
      if (clonedStatus) clonedStatus.hidden = true;
      var clonedProgress = clone.querySelector('[data-newsletter-step-count]');
      if (clonedProgress) { clonedProgress.hidden = false; clonedProgress.textContent = emailStepLabel; }
      dialog.parentNode.appendChild(clone);
      var height = 0;
      try {
        ['parent', 'eleve'].forEach(function (copyPersona) {
          clone.querySelectorAll('[data-newsletter-copy-parent]').forEach(function (element) {
            var copy = element.getAttribute('data-newsletter-copy-' + copyPersona);
            if (copy !== null) {
              if (element.tagName === 'INPUT') element.setAttribute('placeholder', copy);
              else element.innerHTML = copy;
            }
          });
          var clonedSummary = clone.querySelector('[data-newsletter-profile-summary]');
          var finalLevel = level.querySelector('option[value="terminale"]');
          if (clonedSummary) clonedSummary.textContent = personaLabel(copyPersona) + ' · ' + (finalLevel ? finalLevel.label : 'Terminale');
          height = Math.max(height, clone.getBoundingClientRect().height);
        });
      } finally { clone.remove(); }
      if (height) dialog.style.setProperty('--ines-popup-height', Math.ceil(height) + 'px');
    }
    function syncProfile() {
      var pendingLevel = personas.indexOf(persona.value) === -1;
      dialog.dataset.profilePending = String(step === 'profile' && persona.type !== 'hidden' && pendingLevel);
      level.disabled = pendingLevel;
      if (levelField) {
        levelField.hidden = false;
        levelField.inert = false;
        levelField.dataset.levelPending = String(pendingLevel);
        levelField.setAttribute('aria-disabled', String(pendingLevel));
      }
      var dropdown = level.closest('[data-newsletter-dropdown]');
      var trigger = dropdown && dropdown.querySelector('[data-newsletter-select-trigger]');
      if (trigger) {
        if (pendingLevel && trigger.getAttribute('aria-expanded') === 'true') trigger.click();
        trigger.disabled = pendingLevel;
        trigger.setAttribute('aria-disabled', String(pendingLevel));
      }
      if (summary) {
        var choice = level.options && level.options[level.selectedIndex];
        summary.textContent = personas.indexOf(persona.value) !== -1 && levels.indexOf(level.value) !== -1
          ? personaLabel(persona.value) + ' · ' + (choice ? choice.label : level.value)
          : '';
      }
    }
    function showStep(name, moveFocus) {
      clearTimeout(advanceTimer);
      profile.querySelectorAll('[data-newsletter-select-trigger][aria-expanded="true"]').forEach(function (trigger) { trigger.click(); });
      step = name;
      dialog.dataset.popupStep = name;
      form.dataset.newsletterSteps = name;
      profile.hidden = name !== 'profile';
      profile.inert = profile.hidden;
      emailPanel.hidden = name !== 'email';
      emailPanel.inert = emailPanel.hidden;
      if (progress) progress.textContent = name === 'profile' ? profileStepLabel : emailStepLabel;
      syncProfile();
      clearStatus();
      if (moveFocus) focusCurrent();
    }
    function profileValid() {
      return personas.indexOf(persona.value) !== -1 && levels.indexOf(level.value) !== -1
        && persona.validity.valid && level.validity.valid;
    }
    function validateProfile() {
      var invalid = null;
      [persona, level].forEach(function (field) {
        var allowed = field === persona ? personas : levels;
        if (!field.checkValidity() || allowed.indexOf(field.value) === -1) {
          if (!invalid) invalid = field;
        }
      });
      if (!invalid) return true;
      if (status) {
        status.textContent = persona.type === 'hidden' ? 'Choisissez votre classe.' : 'Choisissez votre profil et votre classe.';
        status.hidden = false;
      }
      focusField(invalid);
      return false;
    }
    function continueToEmail() {
      if (complete || !validateProfile()) return;
      showStep('email', true);
    }
    function scheduleAdvance() {
      if (complete || step !== 'profile' || !profileValid()) return;
      clearTimeout(advanceTimer);
      // Let the select replacement finish closing and restoring its own focus
      // before the email panel takes focus, including a repeated class choice.
      advanceTimer = setTimeout(function () {
        if (dialog.open && dialog.isConnected && step === 'profile' && profileValid()) continueToEmail();
      }, 0);
    }
    function levelRadio(target) {
      return target.closest('[data-newsletter-segments][data-name="level"]') && target.closest('[role="radio"]');
    }
    function levelDropdown(target) {
      var dropdown = target.closest('[data-newsletter-dropdown]');
      return dropdown && dropdown.contains(level) ? dropdown : null;
    }
    function syncBack() {
      back.disabled = complete || form.getAttribute('aria-busy') === 'true';
    }
    back.addEventListener('click', function () {
      if (!complete && form.getAttribute('aria-busy') !== 'true') showStep('profile', true);
    });
    if (typeof MutationObserver === 'function') {
      var busyObserver = new MutationObserver(syncBack);
      busyObserver.observe(form, { attributes: true, attributeFilter: ['aria-busy'] });
    }
    [persona, level].forEach(function (field) {
      field.addEventListener('input', syncProfile);
      field.addEventListener('change', syncProfile);
    });
    level.addEventListener('change', function () { if (!browsingLevel) scheduleAdvance(); });
    form.addEventListener('click', function (event) {
      var radio = levelRadio(event.target);
      if ((radio && !radio.disabled) || (levelDropdown(event.target) && event.target.closest('[role="option"]'))) scheduleAdvance();
    });
    // Capture runs before the shared signup adapter regardless of script order.
    // A profile-stage submit advances the flow without registering a contact.
    form.addEventListener('submit', function (event) {
      if (complete || step === 'profile' || !profileValid()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (complete) return;
        if (step !== 'profile') showStep('profile', false);
        continueToEmail();
      }
    }, true);
    form.addEventListener('keydown', function (event) {
      // Arrow/Home/End navigation changes the canonical radio value, but lets
      // keyboard users browse classes before committing with Enter or Space.
      browsingLevel = !!levelRadio(event.target)
        && ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) !== -1;
      if (step !== 'profile' || event.key !== 'Enter'
        || event.target.closest('button, select, [role="radio"], [role="combobox"]')) return;
      event.preventDefault();
      continueToEmail();
    }, true);
    form.addEventListener('keydown', function (event) {
      browsingLevel = false;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var radio = levelRadio(event.target);
      var dropdown = levelDropdown(event.target);
      var trigger = dropdown && dropdown.querySelector('[data-newsletter-select-trigger]');
      if ((radio && !radio.disabled) || (trigger && trigger.getAttribute('aria-expanded') === 'false')) scheduleAdvance();
    });
    form.addEventListener('invalid', function (event) {
      if (event.target === email && step === 'profile') {
        // Native implicit submission validates before emitting submit. Keep its
        // hidden email error from stealing focus and reveal the next step first.
        event.preventDefault();
        continueToEmail();
      } else if ((event.target === persona || event.target === level) && step === 'email') {
        showStep('profile', false);
        focusField(event.target);
      }
    }, true);
    form.addEventListener('reset', function () {
      clearTimeout(advanceTimer);
      setTimeout(function () {
        profile.querySelectorAll('[aria-invalid]').forEach(function (control) { control.removeAttribute('aria-invalid'); });
        showStep('profile', dialog.open);
      }, 0);
    });
    form.addEventListener('ines:newsletter:success', function () {
      complete = true;
      syncBack();
      back.hidden = true;
      if (progress) progress.hidden = true;
      focusCurrent();
    });
    showStep('profile', false);
    window.addEventListener('resize', resize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(resize);
    return { focus: focusCurrent, resize: resize };
  }

  function initialize(dialog) {
    if (initialized.has(dialog) || typeof dialog.showModal !== 'function') return;
    initialized.add(dialog);
    var timer;
    var opener;
    var previousOverflow;
    var accepted = subscribed();
    var once = dialog.dataset.popupOnce !== 'false';
    var delay = Math.max(0, Number(dialog.dataset.popupDelay) || 12) * 1000;
    var dismissDays = Math.max(1, Number(dialog.dataset.popupDismissDays) || 7);
    var preset = params.get('newsletter_glass');
    if (['frosted', 'clear', 'rose'].indexOf(preset) !== -1) dialog.dataset.glassStyle = preset;
    var flow = initializeSteps(dialog);

    function open(from) {
      if (excludedRoute() || (!forced && (accepted || subscribed())) || anotherOverlay(dialog)) return false;
      if (dialog.open) return true;
      clearTimeout(timer);
      opener = from || document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (flow) { flow.resize(); dialog.style.outline = 'none'; dialog.setAttribute('tabindex', '-1'); dialog.focus(); }
      write('sessionStorage', seenKey, '1');
      // A design preview must not consume the visitor's ordinary exposure.
      if (!forced) write('localStorage', seenKey, '1');
      return true;
    }
    function dismiss() {
      if (!dialog.open) return;
      write('localStorage', dismissedKey, String(Date.now() + dismissDays * 86400000));
      dialog.close();
    }
    function schedule(wait) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (accepted || suppressed(once) || excludedRoute() || !dialog.isConnected) return;
        if (document.hidden || anotherOverlay(dialog) || footerVisible()) { schedule(2000); return; }
        open();
      }, wait);
    }
    var control = { dialog: dialog, open: open, stop: function () { clearTimeout(timer); if (dialog.open) dialog.close(); } };
    activePopup = control;
    dialog.querySelector('[data-newsletter-popup-close]').addEventListener('click', dismiss);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = previousOverflow || '';
      dialog.querySelectorAll('[data-newsletter-select-trigger][aria-expanded="true"]').forEach(function (trigger) { trigger.click(); });
      if (opener && opener.isConnected && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    });
    document.addEventListener('ines:newsletter:success', function () {
      accepted = true;
      clearTimeout(timer);
      write('localStorage', subscribedKey, '1');
    });
    if (forced) open();
    else if (dialog.dataset.popupAuto === 'true' && !suppressed(once) && !excludedRoute()
      && !(window.Shopify && window.Shopify.designMode)) schedule(delay);
  }
  function initializeAll(root) {
    if (root.matches && root.matches('[data-newsletter-popup]')) initialize(root);
    root.querySelectorAll('[data-newsletter-popup]').forEach(initialize);
  }

  window.InesNewsletterPopup = {
    open: function (opener) { return activePopup ? activePopup.open(opener) : false; }
  };
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(triggerSelector);
    if (trigger && window.InesNewsletterPopup.open(trigger)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (activePopup && event.target.contains(activePopup.dialog)) { activePopup.stop(); activePopup = null; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  else initializeAll(document);
})();
/* Ecran de remerciement apres inscription (popup) */
(function(){var lastPersona='';document.addEventListener('submit',function(event){var f=event.target&&event.target.elements?event.target.elements.namedItem('persona'):null;if(f&&f.value)lastPersona=f.value;},true);document.addEventListener('ines:newsletter:success',function(event){var form=event.target;var dialog=form&&form.closest?form.closest('.ines-newsletter-popup'):null;if(!dialog)return;var panel=dialog.querySelector('.ines-newsletter-popup__form-panel');if(!panel||panel.querySelector('.ines-newsletter-popup__thanks'))return;var field=form.elements?form.elements.namedItem('persona'):null;var persona=(field&&field.value)||lastPersona;var eleve=persona==='eleve';var box=document.createElement('div');box.className='ines-newsletter-popup__thanks';box.setAttribute('role','status');var title=document.createElement('p');title.className='ines-newsletter-popup__thanks-title';title.textContent='Merci !';var text=document.createElement('p');text.className='ines-newsletter-popup__thanks-text';text.textContent=eleve?'Ton code –20 % t’attend dans ta boîte mail. Pense à vérifier tes spams.':'Votre code –20 % vous attend dans votre boîte mail. Pensez à vérifier vos spams.';var link=document.createElement('a');link.className='ines-newsletter-popup__thanks-button';link.href='/collections';link.textContent='Découvrir les fiches';box.appendChild(title);box.appendChild(text);box.appendChild(link);Array.prototype.forEach.call(panel.children,function(child){child.hidden=true;});panel.appendChild(box);});})();
